import React from "react";
import ProfileSharedContent from "./ProfileSharedContent";
import "../styles/SharedContentModal.css";

function SharedContentModal({
  user,
  contactUserId,
  contactName,
  onClose,
  initialTab = "media",
}) {
  if (!contactUserId) return null;

  return (
    <div className="shared-content-overlay" onClick={onClose}>
      <div className="shared-content-modal" onClick={(e) => e.stopPropagation()}>
        <div className="shared-content-header">
          <button
            type="button"
            className="shared-content-close"
            onClick={onClose}
            aria-label="Close"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
          <div className="shared-content-title-block">
            <h2>Media, links &amp; docs</h2>
            {contactName && (
              <p className="shared-content-subtitle notranslate">{contactName}</p>
            )}
          </div>
        </div>
        <div className="shared-content-body">
          <ProfileSharedContent
            user={user}
            contactUserId={contactUserId}
            initialTab={initialTab}
            embedded
          />
        </div>
      </div>
    </div>
  );
}

export default SharedContentModal;
